import DesktopFooter from './DesktopFooter'
import MobileFooter from './MobileFooter'

const Footer = () => {
  return (
    <footer className="bg-foreground border-foreground/10 mt-auto border-t text-white">
      <DesktopFooter />
      <MobileFooter />
    </footer>
  )
}

export default Footer
